import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import CardIconSizes from './CardIconSizes';

export interface CardIconProps {
    icon: IconTypes | RichIconTypes | JSX.Element;
    iconSize?: CardIconSizes;
}

const isIconTypes = (icon: IconTypes | RichIconTypes | JSX.Element): icon is IconTypes => {
    return typeof icon === typeof IconTypes.FAKTURA_36 && Boolean(Object.values(IconTypes).find((x) => x === icon));
};
const isRichIconTypes = (icon: IconTypes | RichIconTypes | JSX.Element): icon is RichIconTypes => {
    return (
        typeof icon === typeof RichIconTypes.HJERTE_M_PLASTER &&
        Boolean(Object.values(RichIconTypes).find((x) => x === icon))
    );
};

const CardIcon = ({ icon, iconSize }: CardIconProps): JSX.Element => {
    if (isIconTypes(icon) && typeof icon === typeof IconTypes.FAKTURA_36) {
        return <Icon className={classnames('sgw-card-icon', 'icon', iconSize)} type={icon as IconTypes} />;
    }

    if (isRichIconTypes(icon) && typeof icon === typeof RichIconTypes.HJERTE_M_PLASTER) {
        return <RichIcon className={classnames('sgw-card-icon', 'rich-icon', iconSize)} type={icon as RichIconTypes} />;
    }

    return <span className={classnames('sgw-card-icon', iconSize)}>{icon}</span>;
};

export default CardIcon;
